module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"solutions":"Lösungen"},"en":{"solutions":"Solutions"},"it":{"solutions":""},"lt":{"solutions":"Sprendimai"},"pl":{"solutions":"Rozwiązania"}}')
  delete Component.options._Ctor
}
